module.exports = __webpack_public_path__ + "img/2dofEoM.04c02b1f.png";